import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import 'moment/locale/mk';
import { TranslateDirective } from '../shared/translate.directive';
import { FormsModule } from '@angular/forms';

export const MY_DATE_FORMATS = {
  parse: { dateInput: 'DD.MM.YYYY' },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-mat-datepicker-loc',
  standalone: true,
  imports: [MatDatepickerModule, MatFormFieldModule, MatInputModule, TranslateDirective, FormsModule],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'mk' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ],
  templateUrl: './mat-datepicker-loc.component.html',
  styleUrl: './mat-datepicker-loc.component.less'
})
export class MatDatepickerLocComponent {
  private static nextInputId = 0;

  @Input() preselectedDate: Date | null = null;
  @Input() minDate: Date | null = null;
  @Output() dateSelected = new EventEmitter<any>();

  inputId = `date-picker-input-${MatDatepickerLocComponent.nextInputId++}`;
  inputName = `${this.inputId}-name`;

  selectedDate: Date | null = null;
  constructor(private dateAdapter: DateAdapter<any>) {
    moment.locale('mk');
    this.dateAdapter.setLocale('mk');
    moment.locale('mk');

  }

  ngOnInit() {
    if (this.preselectedDate) {
      this.selectedDate = this.preselectedDate;  // convert to moment
    }
  }

  onDateChange(selectedDate: moment.Moment) {
    if (selectedDate != null) {
      const d = new Date(selectedDate.toDate())
      const date = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - d.getTimezoneOffset());
      this.dateSelected.emit(date);
    }
    else{
      this.dateSelected.emit(null);
    }
  }

  clearDate() {
    this.selectedDate = null;
    this.dateSelected.emit(null);
  }
}
